import { useEffect, useState } from 'react';

const formatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit',
});

export const getPragueDate = () => {
  const parts = formatter.formatToParts(new Date());
  return ['year', 'month', 'day'].map(type => parts.find(part => part.type === type)?.value).join('-');
};

// Align the check with minute boundaries: Prague midnight is also a UTC minute boundary.
// A focus check handles background tabs whose timers were suspended overnight.
export const usePragueDate = () => {
  const [today, setToday] = useState(getPragueDate);
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const refresh = () => setToday(getPragueDate());
    const tick = () => {
      refresh();
      timeout = setTimeout(tick, 60_000 - Date.now() % 60_000 + 25);
    };
    tick();
    window.addEventListener('focus', refresh);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('focus', refresh);
    };
  }, []);
  return today;
};
